import './App.css';
import { HomePage } from './app/pages/HomePage/HomePage';

function App() {
  return (
    <>
      <HomePage />
    </>
  );
}

export default App;
